import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";
import HeaderWithoutLogin from "../components/HeaderWithoutLogin";
import theme from "../theme/theme";
import styled from "styled-components";
import { setUserSignupedData } from "../redux/actions";
import { useCallback } from "react";

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 2em;

  .card {
    max-width: 90%;
    margin-top: 10%;
    border-radius: 5px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25),
      -2px 0px 6px rgba(0, 0, 0, 0.25);

    .header {
      padding: 1em;
      background-color: #f9f9f9;
      font-size: 30px;
      font-weight: 700;
      color: ${theme.colors.primaryStrong2X};
      overflow: hidden;
      text-overflow: ellipsis;

      .mailid {
        font-size: 30px;
        font-weight: 700;
        color: ${theme.colors.primary};
      }

      @media (max-width: 480px) {
        .mailid {
          font-size: 18px;
        }
      }
    }

    .body {
      padding: 2em;
      background-color: white;
    }
  }
`;

let interval;

const EmailVerification = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useHistory();

  const { setId } = useSelector((state) => state.user);

  const postContact = useCallback(async () => {
    try {
      const successResponse = await Auth.signIn(
        "strategymarketplace@gmail.com",
        "Pass123!"
      ); //due to backend limitation on the /contact api we have to get the token, even if the user is not logged in yet, this is how we are getting the token to submit the api
      if (successResponse)
        dispatch(
          setUserSignupedData(
            setId?.mailId,
            successResponse?.signInUserSession?.accessToken?.jwtToken
          )
        );
    } catch (error) {
      console.error(error);
    }
  }, [setId, dispatch]);

  useEffect(() => {
    if (!params.isFromModal) postContact();
  }, [postContact]);

  useEffect(() => {
    if (setId?.mailId && params?.mailId && setId?.password) {
      if (setId?.mailId !== params?.mailId) {
        history.push("/login");
      } else {
        interval = setInterval(async () => {
          try {
            const successResponse = await Auth.signIn(
              setId.mailId,
              setId.password
            );
            if (successResponse) {
              history.push("/login");
            }
          } catch (error) {
            if (!error.name === "UserNotConfirmedException") {
              history.push("/login");
            }
          }
        }, 10000);
      }
    } else {
      history.push("/login");
    }
  }, [history, setId?.mailId, setId?.password, params?.mailId, setId]);

  useEffect(() => {
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      <HeaderWithoutLogin isLogOutButtonVisible={false} />
      <BodyWrapper>
        <div className="card">
          <div className="header">
            Welcome
            <span className="mailid">, {params.mailId || ""}</span>
          </div>
          <div className="body">
            <span style={{ fontWeight: "700", fontSize: "20px" }}>
              Verify your email account to confirm your identity
            </span>
            <div style={{ marginTop: "5%" }}>
              You will be automatically redirected to the{" "}
              <span
                onClick={() => {
                  history.push("/login");
                }}
                style={{
                  color: theme.colors.primary,
                  textDecoration: "underline",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
              >
                login
              </span>{" "}
              screen, after verification
            </div>
          </div>
        </div>
      </BodyWrapper>
    </>
  );
};

export default EmailVerification;
